import MarqueeCarouselImage from "@/assets/images/marquee-carousel-1.png";
import { SuccessStoryType } from "@/shared/types/common.types";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

const WebinarMwebCard = ({
  successStory,
}: {
  successStory: SuccessStoryType;
}) => {
  return (
    <Link
      href={successStory.href}
      target="_blank"
      rel="nofollow"
      className={classNames(`group/card pointer-events-none mx-3 flex-grow`)}
    >
      <div
        className={classNames(
          "pointer-events-auto relative flex h-full cursor-pointer flex-col bg-grey-1 transition group-hover/card:bg-purple-0",
          {
            "rounded-b-xl rounded-t-xl group-hover/card:rounded-t-none": true,
          }
        )}
      >
        <div
          className={
            "relative h-[250px] w-[300px] overflow-hidden rounded-t-xl"
          }
        >
          <Image
            src={successStory.image || MarqueeCarouselImage}
            fill
            style={{
              objectFit: "cover",
            }}
            alt={`${successStory.name}'s website`}
          />
        </div>
        <div className={`flex flex-col gap-3 px-3 pb-4 pt-3`}>
          <div className="flex items-center gap-2">
            <div className="relative h-9 w-9 basis-9 overflow-hidden rounded-full bg-grey-4">
              <Image
                src={successStory.avatar || MarqueeCarouselImage}
                fill
                style={{
                  objectFit: "cover",
                }}
                alt={`${successStory.name}'s avatar`}
              />
            </div>
            <div className="flex flex-1 flex-col">
              <h4 className="text-title-14 text-grey-4">{successStory.name}</h4>
              <p className="text-body-10 text-grey-4">
                {successStory.designation}
              </p>
            </div>
            {/* <div className="flex flex-col text-right">
              <p className="text-title-12 text-purple-3">
                {successStory.highlight.main}
              </p>
              <p className="text-body-10 text-grey-4">
                {successStory.highlight.subtext}
              </p>
            </div> */}
          </div>
          <p className="text-body-12 text-grey-4">{successStory.description}</p>
        </div>
      </div>
    </Link>
  );
};

export default WebinarMwebCard;
